import { withNamespaces } from "react-i18next"
import { 
    Card, 
    CardBody, 
    CardText, 
    CardTitle,
    UncontrolledPopover,
    PopoverHeader,
    PopoverBody
} from "reactstrap"
import DateUtils from "src/services/utils/DateUtils";
import {
    INTERNATIONAL_DATE_FORMAT
} from 'src/common/constants';
import { useMemo } from "react";

const Summary = ({
    t,
    geoData = {}
}) => {

    const description = useMemo(() => {
        if (geoData) {
            const dateUtils = new DateUtils();

            const {
                name,
                commodity,
                area,
                landcover_forest_coverage,
                deforestation_risk,
                deforestation_area_ha,
                generation_date,
                country_risk,

                raw_response
            } = geoData;

            if (country_risk === 'low' && commodity !== 'wood') {
                return t("The parcel {{name}} in {{country}} covers {{area}} hectares and is used for {{commodity}} production. The country risk is low and the commodity is not wood, so no geolocation-based deforestation assessment is required. Standard monitoring can continue as part of compliance procedures.", {
                    name: t(name),
                    country: t(raw_response?.properties?.entity),
                    area: (Number(area)).toFixed(1),
                    commodity: t(commodity)
                })
            }

            return t("The parcel {{name}} in {{country}} covers {{area}} hectares and is used for {{commodity}} production. Analysis (as of {{generationDate}} shows a {{defRisk}} deforestation risk, with {{defArea}} hectares affected between {{pStartDate}} and {{pEndDate}}. Forest coverage is {{fCoverage}}%. This supplier requires {{defRiskName}} monitoring under EUDR compliance.", {
                name: t(name),
                country: t(raw_response?.properties?.entity),
                area: (Number(area)).toFixed(1),
                commodity: t(commodity),
                generationDate: dateUtils.convertDateToDate(
                    generation_date,
                    INTERNATIONAL_DATE_FORMAT
                ),
                defRisk: deforestation_risk,
                defArea: (Number(deforestation_area_ha)).toFixed(1),
                pStartDate: dateUtils.convertDateToDate(
                    raw_response?.properties?.production_start,
                    INTERNATIONAL_DATE_FORMAT
                ),
                pEndDate: dateUtils.convertDateToDate(
                    raw_response?.properties?.production_end,
                    INTERNATIONAL_DATE_FORMAT
                ),
                fCoverage: (Number(landcover_forest_coverage) * 100)?.toFixed(0),
                defRiskName: t(deforestation_risk === "high" ? "urgent" : "regular")
            });
        }

        return "";
    }, [ geoData, t ])

    return (
        <Card style={{
            minHeight: 'calc(100% - 24px)'
        }}>
            <CardBody>
                <CardTitle tag="h5">
                    <span className="me-1">
                        {t('Summary')}
                    </span>
                    <i 
                        className="ri-information-line" 
                        style={{
                            cursor: 'pointer'
                        }}
                        id="summary-help-text"
                    />

                    <UncontrolledPopover
                        trigger="hover"
                        target="summary-help-text"
                    >
                        <PopoverHeader>
                            {t('Parcel Risk Summary')}
                        </PopoverHeader>
                        <PopoverBody>
                            <p>
                                {t('This summary provides an overview of the selected parcel, including its location, size, land use, and deforestation risk status.')}
                            </p>
                            <p>
                                {t('It highlights key compliance indicators — such as affected forest area, forest coverage percentage, and overall EUDR risk level — to help you quickly understand whether the supplier’s land use requires further due diligence or monitoring.')}
                            </p>
                        </PopoverBody>
                    </UncontrolledPopover>

                </CardTitle>

                <div style={{
                    maxHeight: '130px',
                    overflowY: 'auto'
                }}>
                    <CardText>
                        {description}
                    </CardText>
                </div>
            </CardBody>
        </Card>
    )
}

export default withNamespaces()(
    Summary
)